<template>
    <div class="page-auth">
        <div class="content">
            <div class="container">
                <div class="card card-auth">
                    <div class="card-body text-center1">
                        <div class="text-center">
                            <img src="../../assets/logo.png" class="img" />
                        </div>
                        <br><br>
                        <h3 class="card-title text-center">Reset Your Password</h3>
                        <form @submit.prevent="forgotPassword">
                            <div class="row g-2">
                                <div class="col-sm-12">
                                    <!-- <label class="form-label">Email address</label><span class="text-danger"> *</span> -->
                                    <input type="text" class="form-control" placeholder="Enter email address"
                                        :class="{ 'is-invalid': errors.email }" v-model="user.email" ref="email" />
                                    <span v-if="errors.email" class="invalid-feedback">{{ errors.email }}</span>
                                </div>
                                <div class="col-sm-12">
                                    <!-- <v-otp-input
                                        ref="otpInput"
                                        input-classes="otp-input m-1 text-center form-control inputotp"
                                        :class="{ 'is-invalid': errors.otp }"
                                        :conditionalClass="p-otp"
                                        separator=""
                                        inputType="letter-numeric"
                                        :num-inputs="6"
                                        v-model:value="p_otp1"
                                        :should-auto-focus="true"
                                        :should-focus-order="true"
                                    />
                                    <span v-if="errors.otp" class="invalid-feedback">{{ errors.otp }}</span> -->
                                    <!-- try starts -->
                                     <!-- <label class="form-label">OTP</label><span class="text-danger"> *</span> -->
                                     <v-otp-input ref="otpInput"
                                        input-classes="otp-input m-1 text-center form-control inputotp"
                                        :class="{ 'is-invalid': errors.otp }"
                                        :conditionalClass="p_otp"
                                        separator=""
                                         inputType="letter-numeric"
                                        :num-inputs="6" v-model:value="p_otp1" :should-auto-focus="true"
                                        :should-focus-order="true"/>
                                        <span v-if="errors.otp" class="invalid-feedback">{{ errors.otp }}</span>
                                        <!-- try ends -->

                                </div>
                                <div class="col-sm-12">
                                    <!-- <label class="form-label">New Password</label><span class="text-danger"> *</span> -->
                                    <input type="password" placeholder="New Password" class="form-control" :class="{'is-invalid': errors.newPassword}" v-model="user.newPassword" @keyup="test(user.newPassword,'newPassword')" />
                                    <span v-if="errors.newPassword" class="invalid-feedback">{{ errors.newPassword }}</span>
                                </div>
                                <div class="col-sm-12">
                                    <!-- <label class="form-label">Confirm Password</label><span class="text-danger"> *</span> -->
                                    <input type="password" placeholder="Confirm Password" class="form-control" :class="{'is-invalid': errors.confirmPassword}" v-model="user.confirmPassword" @keyup="test(user.confirmPassword,'confirmPassword')"/>
                                    <span v-if="errors.confirmPassword" class="invalid-feedback">{{ errors.confirmPassword }}</span>
                                </div>
                                <div class="d-flex justify-content-between"><a class="text-danger"
                                        href="javascript:void(0)"><i class="ri-restart-line"></i> Resend otp</a>
                                <router-link class=""
                                        to="/">Login</router-link></div>
                                <div class="col-sm-12"><button @click="verifyOtp()" href="#" method="submit"
                                        class="btn btn-primary">Submit</button></div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "Forgotpassword",
    data() {
        return {
            user: {
                email: "",
                newPassword: "",
                confirmPassword: "",
                otp: "",
            },
            p_otp: {
                first: '',
                second: '',
                third: '',
                fourth: '',
                fifth: '',
                sixth: ''
                },
            p_otp1: "",
            errors: [],
        };
    },
    mounted() {
        this.$refs.email.focus();
    },
    beforeRouteEnter(to, from, next) {
		next((vm) => {
            console.log('to:-----', to)
			vm.user.email = to.params.email_id ? to.params.email_id : '';
		});
	},
    methods: {
        test( password,field_name){
            console.log("key", password,field_name)
            let vm = this;
            if(field_name=="current_password"){
                vm.errors.current_password="";
            }

            if(field_name=="newPassword"){
                vm.errors.newPassword="";
            }

            if(field_name=="confirmPassword"){
                vm.errors.confirmPassword="";
            }

        },
        verifyOtp() {
            let vm = this;
            let otp = [this.p_otp.first, this.p_otp.second, this.p_otp.third, this.p_otp.fourth, this.p_otp.fifth, this.p_otp.sixth];
            vm.user.otp = otp.join("");
            console.log("otp", vm.user);
            vm.user.otp = vm.p_otp1;
            let loader = vm.$loading.show();
            vm.$store
                .dispatch("auth", { uri: "auth/resetPassword", data: vm.user  })
                .then((response) => {
                    loader.hide();
                    alert(response.data.message);
                    vm.$router.push("/");
                })
                .catch(function (error) {
                    loader.hide();
                    vm.errors = error.response.data.errors;
                    vm.$store.dispatch("error", error.response.data.message);
                });
        },
    },
};
</script>
<style scoped>
/* .inputotp {
    height: 50px !important;
    width: 50px !important;
    margin: 2px !important;
  } */

.form-label{
        font-weight: 500;
    font-size: .8125rem;
}
</style>
